export default "__VITE_ASSET__CNCZ$eiF__"